import { CLEAR_SELECTION } from '../constants';

export default function (scope) {
  return {
    type: CLEAR_SELECTION,
    scope,
  };
}
